"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetedConsoleLogEventsTracker = exports.ConsoleLogEventsTracker = void 0;
const ConsoleLogEventsTracker = (tracker) => {
    return {
        async track(event) {
            await tracker.track(event);
            console.log(`Track event: ${JSON.stringify(event)}`);
        },
    };
};
exports.ConsoleLogEventsTracker = ConsoleLogEventsTracker;
const TargetedConsoleLogEventsTracker = (tracker) => {
    return {
        async track(event) {
            await tracker.track(event);
            console.log(`Track event to all targets: ${JSON.stringify(event)}`);
        },
        async trackWithTarget(event, target) {
            await tracker.trackWithTarget(event, target);
            console.log(`Track event to ${target}: ${JSON.stringify(event)}`);
        },
        async trackWithTargets(event, targets) {
            await tracker.trackWithTargets(event, targets);
            console.log(`Track event to ${targets.join(', ')}: ${JSON.stringify(event)}`);
        },
    };
};
exports.TargetedConsoleLogEventsTracker = TargetedConsoleLogEventsTracker;
